import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

/**
 * Realm-style data routing: stamp the environment's database + collection
 * names onto every request to OUR API. The API validates them against its
 * whitelist and rejects requests that don't carry them — so which data a
 * build touches is decided here, by the frontend environment, exactly like
 * the old Realm client.
 */
@Injectable()
export class DbContextInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (!req.url.startsWith(environment.apiBaseUrl)) return next.handle(req);
    return next.handle(
      req.clone({
        setHeaders: {
          'x-advocad-db': environment.db.name,
          'x-activity-collection': environment.db.activityCollection,
          'x-user-profile-collection': environment.db.userProfileCollection,
        },
      }),
    );
  }
}
